import React from "react";
import { AgentName } from "../../config/config";
import { Helmet } from 'react-helmet';

const Hero = () => {
  const formattedAgentName = AgentName.charAt(0).toUpperCase() + AgentName.slice(1);

  return (
    <section className="w-full py-24 md:py-32 text-center text-gray-900 container mx-auto">
        <Helmet>
        <title>CNFans Spreadsheet</title>
        <meta name="description" content="This website is a cnfans spreadsheet containing over 7,000+ of best CNFans finds, The spreadsheet gets updated weekly with the best deals and new items!" />
        <link rel="canonical" href="https://cnfansspreadsheet.com/" />
      </Helmet>
      <div className="container px-4 md:px-6">
        <header className="heroHeaders">
          {/* 🚀 H1 - Primary keyword with value proposition */}
          <h1 className="text-2xl md:text-4xl font-bold tracking-tight text-gray-800 mb-6">
            <strong>CNFans Spreadsheet</strong> — Updated for 2025
          </h1>

          {/* 🚀 H2 - Secondary keyword + value */}
          <h2 className="text-base md:text-3xl font-semibold tracking-tight text-gray-700 mb-4">
          Browse 7,000+ <strong>CNFans Finds</strong> 
          </h2>

          {/* 🚀 Optimized Paragraph with benefits and keywords */}
          <p className="text-xs sm:text-lg md:text-lg text-gray-600 leading-relaxed px-4 md:px-0 max-w-2xl mx-auto mb-8">
            Browse over 7,000+ <strong>CNfans</strong> products, including shoes, clothing, accessories, and more, all with prices listed in USD. 
            Whether you're after <strong>cheap</strong> <strong>budget</strong> deals or premium items, our spreadsheet is updated weekly! <br/> <br/> Don’t forget to bookmark this page "CTRL + D" to keep up with the latest finds!
          </p>

          {/* 🚀 Call to Action with urgency */}
          <div className="flex justify-center">
            <a
              href="/products"
              className="btn6 text-sm sm:text-sm px-4 sm:px-8 py-3 rounded-md text-white transition-all hover:bg-slate-800 hover:text-white"
            >
              Browse {formattedAgentName} Products
            </a>
          </div>
        </header>
      </div>
    </section>
  );
};

export default React.memo(Hero);
